import { useState, useCallback } from 'react';

const STORAGE_KEY = 'health-tracker-collapsed-sections';

function getCollapsedSections() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : {};
  } catch {
    return {};
  }
}

function setCollapsedSections(sections) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(sections));
  } catch {
    // localStorage unavailable
  }
}

export default function useCollapsibleState(sectionId) {
  const [isCollapsed, setIsCollapsed] = useState(() => {
    return !!getCollapsedSections()[sectionId];
  });

  const toggleCollapsed = useCallback(() => {
    setIsCollapsed(prev => {
      const next = !prev;
      const sections = getCollapsedSections();
      if (next) {
        sections[sectionId] = true;
      } else {
        delete sections[sectionId];
      }
      setCollapsedSections(sections);
      return next;
    });
  }, [sectionId]);

  return [isCollapsed, toggleCollapsed];
}
